/*!
 * Gettwork Accessibility Widget
 * v1.0.0 — drop-in accessibility plugin (Hebrew/English, RTL/LTR, zero deps)
 *
 * USAGE:
 *   <script src="a11y-widget.js" defer></script>
 *
 * OPTIONAL CONFIG (set BEFORE loading the script):
 *   <script>
 *     window.A11yWidgetConfig = {
 *       position:    'bottom-left',  // 'bottom-left' | 'bottom-right' | 'top-left' | 'top-right'
 *       lang:        'he',           // 'he' | 'en'
 *       accentColor: '#FF6B1A',      // brand color for the button + accents
 *       inkColor:    '#1B2434',      // dark text color
 *       storageKey:  'a11y-prefs',
 *       storageDays: 30,
 *       statementUrl:'https://monsenyor.co.il/pages/%D7%94%D7%A6%D7%94%D7%A8%D7%AA-%D7%A0%D7%92%D7%99%D7%A9%D7%95%D7%AA'  // link to your accessibility statement
 *     };
 *   </script>
 *   <script src="a11y-widget.js" defer></script>
 *
 * FEATURES:
 *   - Text size (5 levels: 100% to 150%)
 *   - High contrast mode
 *   - Grayscale (saturation off)
 *   - Highlight links (bold outlines)
 *   - Readable font (Arial system swap)
 *   - Pause animations
 *   - Big cursor
 *   - Hide images (replace with alt text)
 *   - Reset all
 *   - Settings persist in localStorage (30 days default)
 *   - Full keyboard support (Tab, Enter, Escape)
 *   - ARIA labels, screen-reader friendly
 *
 * NO DEPENDENCIES. NO REMOTE CALLS. ~600 lines, ~18KB.
 */

(function () {
  'use strict';

  if (window.__a11yWidgetLoaded) return;
  window.__a11yWidgetLoaded = true;

  // ============================================================
  // CONFIG
  // ============================================================
  var defaults = {
    position: 'bottom-left',
    lang: 'he',
    accentColor: '#FF6B1A',
    inkColor: '#1B2434',
    storageKey: 'a11y-widget-prefs',
    storageDays: 30,
    statementUrl: 'accessibility.html',
    offsetDesktop: 24,      // px from edges on desktop
    offsetMobile: 24,       // px from edges on mobile
    bottomOffsetMobile: 24  // override bottom on mobile (e.g. 100 if you have a sticky CTA)
  };
  var config = Object.assign({}, defaults, window.A11yWidgetConfig || {});

  // ============================================================
  // LABELS
  // ============================================================
  var labels = {
    he: {
      dir: 'rtl',
      openBtn: 'תפריט נגישות',
      title: 'הגדרות נגישות',
      close: 'סגירה',
      textSize: 'גודל טקסט',
      textInc: 'הגדל',
      textDec: 'הקטן',
      textReset: 'איפוס',
      contrast: 'ניגודיות גבוהה',
      grayscale: 'מצב שחור-לבן',
      links: 'הדגשת קישורים',
      font: 'פונט קריא',
      pause: 'הקפאת אנימציות',
      cursor: 'סמן מוגדל',
      hideImg: 'הסתר תמונות',
      reset: 'איפוס כל ההגדרות',
      statement: 'הצהרת נגישות',
      tip: 'ניתן לנווט בלוח הזה באמצעות Tab. לסגירה - מקש Escape.',
      on: 'מופעל',
      off: 'כבוי',
      announceOn: 'מופעל',
      announceOff: 'בוטל'
    },
    en: {
      dir: 'ltr',
      openBtn: 'Accessibility Menu',
      title: 'Accessibility Settings',
      close: 'Close',
      textSize: 'Text Size',
      textInc: 'Increase',
      textDec: 'Decrease',
      textReset: 'Reset',
      contrast: 'High Contrast',
      grayscale: 'Grayscale',
      links: 'Highlight Links',
      font: 'Readable Font',
      pause: 'Pause Animations',
      cursor: 'Big Cursor',
      hideImg: 'Hide Images',
      reset: 'Reset All Settings',
      statement: 'Accessibility Statement',
      tip: 'Navigate this panel with Tab. Press Escape to close.',
      on: 'On',
      off: 'Off',
      announceOn: 'enabled',
      announceOff: 'disabled'
    }
  };
  var t = labels[config.lang] || labels.he;

  // ============================================================
  // STATE
  // ============================================================
  var defaultPrefs = {
    textScale: 1,         // 1.0 - 1.5
    contrast: false,
    grayscale: false,
    links: false,
    font: false,
    pause: false,
    cursor: false,
    hideImg: false
  };

  function loadPrefs() {
    try {
      var raw = localStorage.getItem(config.storageKey);
      if (!raw) return Object.assign({}, defaultPrefs);
      var parsed = JSON.parse(raw);
      // Expiry check
      if (parsed.__expiry && parsed.__expiry < Date.now()) {
        localStorage.removeItem(config.storageKey);
        return Object.assign({}, defaultPrefs);
      }
      var p = Object.assign({}, defaultPrefs);
      Object.keys(defaultPrefs).forEach(function (k) {
        if (k in parsed) p[k] = parsed[k];
      });
      return p;
    } catch (e) {
      return Object.assign({}, defaultPrefs);
    }
  }

  function savePrefs() {
    try {
      var data = Object.assign({}, prefs, {
        __expiry: Date.now() + config.storageDays * 24 * 60 * 60 * 1000
      });
      localStorage.setItem(config.storageKey, JSON.stringify(data));
    } catch (e) { /* localStorage blocked - ignore */ }
  }

  var prefs = loadPrefs();

  // ============================================================
  // CSS INJECTION
  // ============================================================
  var STYLE_ID = 'a11y-widget-styles';

  function buildBaseCSS() {
    var pos = positionStyles(config.position);
    var dir = t.dir;
    return [
      '.a11y-widget-root, .a11y-widget-root *, .a11y-widget-root *::before, .a11y-widget-root *::after { box-sizing: border-box; font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, "Helvetica Neue", sans-serif !important; }',
      '.a11y-widget-root { position: fixed; ' + pos + '; z-index: 2147483646; direction: ' + dir + '; }',
      // Button
      '.a11y-widget-btn { ',
      '  width: 56px; height: 56px; border-radius: 50%; border: 0; cursor: pointer; ',
      '  background: ' + config.accentColor + '; color: #fff; ',
      '  display: inline-flex; align-items: center; justify-content: center; ',
      '  box-shadow: 0 8px 24px rgba(0,0,0,.22), 0 2px 6px rgba(0,0,0,.10); ',
      '  transition: transform .2s ease, box-shadow .2s ease, background .15s ease; ',
      '  outline: 0; padding: 0; font-size: 0; line-height: 0; ',
      '}',
      '.a11y-widget-btn:hover { transform: scale(1.05); box-shadow: 0 12px 30px rgba(0,0,0,.28), 0 4px 8px rgba(0,0,0,.14); }',
      '.a11y-widget-btn:focus-visible { box-shadow: 0 0 0 3px #fff, 0 0 0 6px ' + config.accentColor + ', 0 8px 24px rgba(0,0,0,.22) !important; }',
      '.a11y-widget-btn svg { display: block; width: 30px; height: 30px; fill: #fff; }',
      // Panel
      '.a11y-widget-panel { ',
      '  position: absolute; ' + panelAnchor(config.position) + '; ',
      '  width: 320px; max-width: calc(100vw - 32px); ',
      '  background: #fff; color: ' + config.inkColor + '; ',
      '  border-radius: 18px; ',
      '  box-shadow: 0 20px 60px rgba(0,0,0,.25), 0 4px 14px rgba(0,0,0,.10); ',
      '  border: 1px solid rgba(0,0,0,.06); ',
      '  padding: 0; ',
      '  opacity: 0; transform: scale(.92) translateY(8px); pointer-events: none; ',
      '  transform-origin: ' + transformOrigin(config.position) + '; ',
      '  transition: opacity .2s ease, transform .22s cubic-bezier(.2,.8,.2,1); ',
      '  max-height: calc(100vh - 100px); overflow-y: auto; ',
      '}',
      '.a11y-widget-root.is-open .a11y-widget-panel { opacity: 1; transform: scale(1) translateY(0); pointer-events: auto; }',
      // Header
      '.a11y-widget-header { ',
      '  display: flex; align-items: center; justify-content: space-between; gap: 8px; ',
      '  padding: 18px 20px 14px; border-bottom: 1px solid rgba(0,0,0,.08); ',
      '}',
      '.a11y-widget-title { ',
      '  font-size: 16px; font-weight: 700; margin: 0; color: ' + config.inkColor + '; letter-spacing: -.2px; ',
      '}',
      '.a11y-widget-close { ',
      '  width: 32px; height: 32px; border-radius: 8px; border: 0; cursor: pointer; ',
      '  background: transparent; color: ' + config.inkColor + '; ',
      '  display: inline-flex; align-items: center; justify-content: center; ',
      '  transition: background .15s ease; outline: 0; ',
      '}',
      '.a11y-widget-close:hover { background: rgba(0,0,0,.06); }',
      '.a11y-widget-close:focus-visible { box-shadow: 0 0 0 2px ' + config.accentColor + ' inset; }',
      // Body
      '.a11y-widget-body { padding: 14px 16px 8px; }',
      // Text size row
      '.a11y-widget-tsize { ',
      '  display: flex; align-items: center; justify-content: space-between; ',
      '  padding: 10px 12px; border-radius: 12px; margin-bottom: 8px; ',
      '  background: rgba(0,0,0,.03); ',
      '}',
      '.a11y-widget-tsize-label { font-size: 13.5px; font-weight: 600; color: ' + config.inkColor + '; }',
      '.a11y-widget-tsize-controls { display: inline-flex; gap: 6px; align-items: center; }',
      '.a11y-widget-tsize-btn { ',
      '  width: 32px; height: 32px; border-radius: 8px; border: 1px solid rgba(0,0,0,.10); ',
      '  background: #fff; color: ' + config.inkColor + '; cursor: pointer; ',
      '  display: inline-flex; align-items: center; justify-content: center; ',
      '  font-size: 16px; font-weight: 700; line-height: 1; padding: 0; outline: 0; ',
      '  transition: background .15s, border-color .15s; ',
      '}',
      '.a11y-widget-tsize-btn:hover { background: rgba(0,0,0,.04); border-color: rgba(0,0,0,.18); }',
      '.a11y-widget-tsize-btn:focus-visible { box-shadow: 0 0 0 2px ' + config.accentColor + '; border-color: ' + config.accentColor + '; }',
      '.a11y-widget-tsize-val { ',
      '  min-width: 44px; text-align: center; font-size: 13.5px; font-weight: 700; ',
      '  font-variant-numeric: tabular-nums; color: ' + config.inkColor + '; ',
      '}',
      // Toggle button (each feature)
      '.a11y-widget-toggle { ',
      '  display: flex; align-items: center; justify-content: space-between; gap: 10px; ',
      '  width: 100%; padding: 11px 12px; margin-bottom: 4px; ',
      '  background: transparent; border: 1px solid transparent; border-radius: 10px; ',
      '  text-align: ' + (dir === 'rtl' ? 'right' : 'left') + '; cursor: pointer; ',
      '  color: ' + config.inkColor + '; font-size: 14px; font-weight: 500; ',
      '  transition: background .15s, border-color .15s; outline: 0; ',
      '}',
      '.a11y-widget-toggle:hover { background: rgba(0,0,0,.04); }',
      '.a11y-widget-toggle:focus-visible { border-color: ' + config.accentColor + '; }',
      '.a11y-widget-toggle[aria-pressed="true"] { background: ' + hexToRgba(config.accentColor, 0.10) + '; }',
      '.a11y-widget-toggle-label { display: inline-flex; align-items: center; gap: 10px; min-width: 0; }',
      '.a11y-widget-toggle-ico { ',
      '  width: 28px; height: 28px; border-radius: 8px; ',
      '  background: rgba(0,0,0,.05); color: ' + config.inkColor + '; ',
      '  display: inline-flex; align-items: center; justify-content: center; flex-shrink: 0; ',
      '}',
      '.a11y-widget-toggle[aria-pressed="true"] .a11y-widget-toggle-ico { background: ' + config.accentColor + '; color: #fff; }',
      '.a11y-widget-toggle-ico svg { width: 16px; height: 16px; }',
      '.a11y-widget-toggle-text { font-size: 14px; font-weight: 500; }',
      // Switch indicator
      '.a11y-widget-switch { ',
      '  width: 34px; height: 20px; border-radius: 999px; background: rgba(0,0,0,.18); ',
      '  position: relative; transition: background .2s; flex-shrink: 0; ',
      '}',
      '.a11y-widget-switch::after { ',
      '  content: ""; position: absolute; top: 2px; ' + (dir === 'rtl' ? 'right' : 'left') + ': 2px; ',
      '  width: 16px; height: 16px; border-radius: 50%; background: #fff; ',
      '  transition: transform .22s cubic-bezier(.2,.8,.2,1); ',
      '  box-shadow: 0 1px 3px rgba(0,0,0,.2); ',
      '}',
      '.a11y-widget-toggle[aria-pressed="true"] .a11y-widget-switch { background: ' + config.accentColor + '; }',
      '.a11y-widget-toggle[aria-pressed="true"] .a11y-widget-switch::after { transform: translateX(' + (dir === 'rtl' ? '-14px' : '14px') + '); }',
      // Reset button
      '.a11y-widget-reset { ',
      '  display: block; width: calc(100% - 24px); margin: 8px 12px 4px; ',
      '  padding: 10px; border: 0; border-radius: 10px; cursor: pointer; ',
      '  background: rgba(0,0,0,.04); color: ' + config.inkColor + '; ',
      '  font-size: 13.5px; font-weight: 600; outline: 0; ',
      '  transition: background .15s; ',
      '}',
      '.a11y-widget-reset:hover { background: rgba(0,0,0,.08); }',
      '.a11y-widget-reset:focus-visible { box-shadow: 0 0 0 2px ' + config.accentColor + ' inset; }',
      // Footer
      '.a11y-widget-footer { ',
      '  padding: 10px 16px 14px; border-top: 1px solid rgba(0,0,0,.06); margin-top: 8px; ',
      '  font-size: 12px; color: rgba(0,0,0,.55); text-align: center; ',
      '}',
      '.a11y-widget-footer a { color: ' + config.accentColor + '; font-weight: 700; text-decoration: none; }',
      '.a11y-widget-footer a:hover { text-decoration: underline; }',
      '.a11y-widget-tip { ',
      '  padding: 8px 12px; margin: 0 12px 8px; ',
      '  background: rgba(0,0,0,.03); border-radius: 8px; ',
      '  font-size: 11.5px; line-height: 1.45; color: rgba(0,0,0,.6); text-align: center; ',
      '}',
      // SR-only
      '.a11y-widget-sr { position: absolute !important; width: 1px !important; height: 1px !important; padding: 0 !important; margin: -1px !important; overflow: hidden !important; clip: rect(0,0,0,0) !important; white-space: nowrap !important; border: 0 !important; }',
      // Mobile
      '@media (max-width: 768px) {',
      '  .a11y-widget-root { ' + positionStyles(config.position, true) + ' }',
      '  .a11y-widget-btn { width: 50px; height: 50px; }',
      '  .a11y-widget-btn svg { width: 26px; height: 26px; }',
      '  .a11y-widget-panel { width: calc(100vw - 32px); ' + panelAnchor(config.position, true) + ' }',
      '}'
    ].join('\n');
  }

  function positionStyles(p, mobile) {
    var off = mobile ? config.offsetMobile : config.offsetDesktop;
    var bottomOff = mobile ? config.bottomOffsetMobile : config.offsetDesktop;
    switch (p) {
      case 'bottom-right': return 'bottom: ' + bottomOff + 'px; right: ' + off + 'px; top: auto; left: auto;';
      case 'top-left':     return 'top: ' + off + 'px; left: ' + off + 'px; bottom: auto; right: auto;';
      case 'top-right':    return 'top: ' + off + 'px; right: ' + off + 'px; bottom: auto; left: auto;';
      case 'bottom-left':
      default:             return 'bottom: ' + bottomOff + 'px; left: ' + off + 'px; top: auto; right: auto;';
    }
  }

  function panelAnchor(p, mobile) {
    var btnSize = mobile ? 50 : 56;
    var gap = 12;
    if (p.indexOf('bottom') === 0) {
      return (p.indexOf('left') !== -1 ? 'left: 0' : 'right: 0') + '; bottom: ' + (btnSize + gap) + 'px; top: auto;';
    }
    return (p.indexOf('left') !== -1 ? 'left: 0' : 'right: 0') + '; top: ' + (btnSize + gap) + 'px; bottom: auto;';
  }

  function transformOrigin(p) {
    var vert = p.indexOf('bottom') === 0 ? 'bottom' : 'top';
    var horz = p.indexOf('left') !== -1 ? 'left' : 'right';
    return vert + ' ' + horz;
  }

  function hexToRgba(hex, alpha) {
    var c = hex.replace('#', '');
    if (c.length === 3) c = c.split('').map(function (x) { return x + x; }).join('');
    var r = parseInt(c.substring(0, 2), 16);
    var g = parseInt(c.substring(2, 4), 16);
    var b = parseInt(c.substring(4, 6), 16);
    return 'rgba(' + r + ',' + g + ',' + b + ',' + alpha + ')';
  }

  // Feature CSS (applied to <html> via data-attributes)
  function buildFeatureCSS() {
    return [
      // Text scale (uses CSS variable on html)
      'html[data-a11y-tscale] { font-size: calc(16px * var(--a11y-tscale)) !important; }',

      // High contrast
      'html[data-a11y-contrast="1"] body > *:not(.a11y-widget-root):not(.a11y-widget-root *) { filter: contrast(1.4) brightness(1.05) !important; }',

      // Grayscale
      'html[data-a11y-grayscale="1"] body > *:not(.a11y-widget-root):not(.a11y-widget-root *) { filter: grayscale(1) !important; }',
      'html[data-a11y-contrast="1"][data-a11y-grayscale="1"] body > *:not(.a11y-widget-root):not(.a11y-widget-root *) { filter: contrast(1.4) brightness(1.05) grayscale(1) !important; }',

      // Highlight links
      'html[data-a11y-links="1"] body :not(.a11y-widget-root) a:not(.a11y-widget-root a) { ',
      '  outline: 2px solid #ff0 !important; outline-offset: 2px !important; ',
      '  background: #000 !important; color: #ff0 !important; ',
      '  text-decoration: underline !important; font-weight: 800 !important; ',
      '  padding: 2px 4px !important; border-radius: 3px !important; ',
      '}',

      // Readable font
      'html[data-a11y-font="1"] body :not(.a11y-widget-root):not(.a11y-widget-root *) { ',
      '  font-family: Arial, "Helvetica Neue", Helvetica, sans-serif !important; ',
      '  letter-spacing: 0 !important; ',
      '}',

      // Pause animations
      'html[data-a11y-pause="1"] body *:not(.a11y-widget-root):not(.a11y-widget-root *), ',
      'html[data-a11y-pause="1"] body *:not(.a11y-widget-root):not(.a11y-widget-root *)::before, ',
      'html[data-a11y-pause="1"] body *:not(.a11y-widget-root):not(.a11y-widget-root *)::after { ',
      '  animation: none !important; transition: none !important; ',
      '  scroll-behavior: auto !important; ',
      '}',

      // Big cursor
      'html[data-a11y-cursor="1"] body, html[data-a11y-cursor="1"] body *:not(.a11y-widget-root):not(.a11y-widget-root *) { ',
      '  cursor: url("data:image/svg+xml;utf8,<svg xmlns=\'http://www.w3.org/2000/svg\' width=\'40\' height=\'40\' viewBox=\'0 0 24 24\'><path d=\'M3 2l7 18 2-8 8-2z\' fill=\'%23FFFF00\' stroke=\'%23000\' stroke-width=\'1.5\' stroke-linejoin=\'round\'/></svg>") 4 4, auto !important; ',
      '}',
      'html[data-a11y-cursor="1"] body a:not(.a11y-widget-root a), ',
      'html[data-a11y-cursor="1"] body button:not(.a11y-widget-root button), ',
      'html[data-a11y-cursor="1"] body [role="button"]:not(.a11y-widget-root [role="button"]) { ',
      '  cursor: url("data:image/svg+xml;utf8,<svg xmlns=\'http://www.w3.org/2000/svg\' width=\'40\' height=\'40\' viewBox=\'0 0 24 24\'><path d=\'M8 2v12l3-3 2 6 3-1-2-6h4z\' fill=\'%23FFFF00\' stroke=\'%23000\' stroke-width=\'1.5\' stroke-linejoin=\'round\'/></svg>") 12 4, pointer !important; ',
      '}',

      // Hide images
      'html[data-a11y-hideimg="1"] body img:not(.a11y-widget-root img), ',
      'html[data-a11y-hideimg="1"] body picture:not(.a11y-widget-root picture), ',
      'html[data-a11y-hideimg="1"] body video:not(.a11y-widget-root video) { ',
      '  visibility: hidden !important; position: relative !important; ',
      '}',
      'html[data-a11y-hideimg="1"] body img:not(.a11y-widget-root img)::after { ',
      '  content: attr(alt); visibility: visible; position: absolute; inset: 0; ',
      '  background: #f0f0f0; color: #333; padding: 8px; ',
      '  display: flex; align-items: center; justify-content: center; ',
      '  font-size: 14px; border: 2px dashed #999; ',
      '}'
    ].join('\n');
  }

  function injectCSS() {
    if (document.getElementById(STYLE_ID)) return;
    var s = document.createElement('style');
    s.id = STYLE_ID;
    s.type = 'text/css';
    s.appendChild(document.createTextNode(buildBaseCSS() + '\n' + buildFeatureCSS()));
    document.head.appendChild(s);
  }

  // ============================================================
  // ICONS (inline SVG)
  // ============================================================
  var ICONS = {
    main: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm-4.5 5h9a1.5 1.5 0 0 1 0 3h-2v3l2.2 6.4a1.5 1.5 0 1 1-2.8 1l-1.9-5.5h-.5l-1.9 5.5a1.5 1.5 0 1 1-2.8-1L9 13v-3H7.5a1.5 1.5 0 0 1 0-3z"/></svg>',
    close: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>',
    contrast: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M12 3v18M3 12h9" fill="currentColor"/><path d="M12 3a9 9 0 0 1 0 18z" fill="currentColor"/></svg>',
    grayscale: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M3 12h18"/></svg>',
    links: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M10 13a5 5 0 0 0 7.5.5l3-3a5 5 0 1 0-7-7l-1.5 1.5"/><path d="M14 11a5 5 0 0 0-7.5-.5l-3 3a5 5 0 1 0 7 7l1.5-1.5"/></svg>',
    font: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 7V4h16v3M9 20h6M12 4v16"/></svg>',
    pause: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="6" y="4" width="4" height="16"/><rect x="14" y="4" width="4" height="16"/></svg>',
    cursor: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 2l7 18 2-8 8-2z"/></svg>',
    image: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg>'
  };

  // ============================================================
  // BUILD WIDGET DOM
  // ============================================================
  var root, btn, panel;

  function buildWidget() {
    root = document.createElement('div');
    root.className = 'a11y-widget-root';
    root.setAttribute('dir', t.dir);

    // Button
    btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'a11y-widget-btn';
    btn.setAttribute('aria-label', t.openBtn);
    btn.setAttribute('aria-haspopup', 'dialog');
    btn.setAttribute('aria-expanded', 'false');
    btn.innerHTML = ICONS.main + '<span class="a11y-widget-sr">' + t.openBtn + '</span>';
    root.appendChild(btn);

    // Panel
    panel = document.createElement('div');
    panel.className = 'a11y-widget-panel';
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-label', t.title);
    panel.setAttribute('aria-modal', 'false');
    panel.innerHTML = panelHTML();
    root.appendChild(panel);

    return root;
  }

  function panelHTML() {
    var ts = Math.round(prefs.textScale * 100);
    return [
      '<div class="a11y-widget-header">',
      '  <h2 class="a11y-widget-title">' + t.title + '</h2>',
      '  <button type="button" class="a11y-widget-close" aria-label="' + t.close + '">' + ICONS.close + '</button>',
      '</div>',
      '<div class="a11y-widget-body">',
      // Text size
      '  <div class="a11y-widget-tsize" role="group" aria-labelledby="a11y-tsize-label">',
      '    <span class="a11y-widget-tsize-label" id="a11y-tsize-label">' + t.textSize + '</span>',
      '    <div class="a11y-widget-tsize-controls">',
      '      <button type="button" class="a11y-widget-tsize-btn" data-action="tdec" aria-label="' + t.textDec + '">A−</button>',
      '      <span class="a11y-widget-tsize-val" aria-live="polite">' + ts + '%</span>',
      '      <button type="button" class="a11y-widget-tsize-btn" data-action="tinc" aria-label="' + t.textInc + '">A+</button>',
      '    </div>',
      '  </div>',
      // Feature toggles
      toggleHTML('contrast', t.contrast, ICONS.contrast),
      toggleHTML('grayscale', t.grayscale, ICONS.grayscale),
      toggleHTML('links',     t.links,     ICONS.links),
      toggleHTML('font',      t.font,      ICONS.font),
      toggleHTML('pause',     t.pause,     ICONS.pause),
      toggleHTML('cursor',    t.cursor,    ICONS.cursor),
      toggleHTML('hideImg',   t.hideImg,   ICONS.image),
      '</div>',
      '<button type="button" class="a11y-widget-reset" data-action="reset">' + t.reset + '</button>',
      '<div class="a11y-widget-tip">' + t.tip + '</div>',
      '<div class="a11y-widget-footer">',
      '  <a href="' + config.statementUrl + '">' + t.statement + '</a>',
      '</div>'
    ].join('');
  }

  function toggleHTML(key, label, icon) {
    var pressed = prefs[key] ? 'true' : 'false';
    return [
      '<button type="button" class="a11y-widget-toggle" data-toggle="' + key + '" aria-pressed="' + pressed + '">',
      '  <span class="a11y-widget-toggle-label">',
      '    <span class="a11y-widget-toggle-ico">' + icon + '</span>',
      '    <span class="a11y-widget-toggle-text">' + label + '</span>',
      '  </span>',
      '  <span class="a11y-widget-switch" aria-hidden="true"></span>',
      '</button>'
    ].join('');
  }

  // ============================================================
  // APPLY PREFS TO PAGE
  // ============================================================
  function applyPrefs() {
    var h = document.documentElement;
    // Text scale
    if (prefs.textScale !== 1) {
      h.style.setProperty('--a11y-tscale', prefs.textScale);
      h.setAttribute('data-a11y-tscale', prefs.textScale);
    } else {
      h.style.removeProperty('--a11y-tscale');
      h.removeAttribute('data-a11y-tscale');
    }
    // Toggles
    ['contrast', 'grayscale', 'links', 'font', 'pause', 'cursor', 'hideImg'].forEach(function (key) {
      var attr = 'data-a11y-' + key.toLowerCase();
      if (prefs[key]) h.setAttribute(attr, '1');
      else h.removeAttribute(attr);
    });
  }

  // ============================================================
  // INTERACTIONS
  // ============================================================
  function openPanel() {
    root.classList.add('is-open');
    btn.setAttribute('aria-expanded', 'true');
    // Focus first interactive element in panel
    setTimeout(function () {
      var firstFocusable = panel.querySelector('button, [tabindex]:not([tabindex="-1"])');
      if (firstFocusable) firstFocusable.focus();
    }, 50);
  }

  function closePanel(returnFocus) {
    root.classList.remove('is-open');
    btn.setAttribute('aria-expanded', 'false');
    if (returnFocus) btn.focus();
  }

  function togglePanel() {
    if (root.classList.contains('is-open')) closePanel(true);
    else openPanel();
  }

  function setTextScale(delta) {
    var s = Math.round((prefs.textScale + delta) * 10) / 10;
    if (s < 1) s = 1;
    if (s > 1.5) s = 1.5;
    prefs.textScale = s;
    applyPrefs();
    savePrefs();
    var valEl = panel.querySelector('.a11y-widget-tsize-val');
    if (valEl) valEl.textContent = Math.round(s * 100) + '%';
  }

  function toggleFeature(key) {
    prefs[key] = !prefs[key];
    var btnEl = panel.querySelector('[data-toggle="' + key + '"]');
    if (btnEl) btnEl.setAttribute('aria-pressed', prefs[key] ? 'true' : 'false');
    applyPrefs();
    savePrefs();
    announce(getLabelFor(key) + ' ' + (prefs[key] ? t.announceOn : t.announceOff));
  }

  function getLabelFor(key) {
    return ({ contrast: t.contrast, grayscale: t.grayscale, links: t.links, font: t.font, pause: t.pause, cursor: t.cursor, hideImg: t.hideImg })[key] || key;
  }

  function resetAll() {
    prefs = Object.assign({}, defaultPrefs);
    try { localStorage.removeItem(config.storageKey); } catch (e) {}
    applyPrefs();
    refreshPanel();
  }

  function refreshPanel() {
    panel.innerHTML = panelHTML();
    bindPanelEvents();
  }

  // ============================================================
  // SCREEN-READER ANNOUNCEMENTS
  // ============================================================
  var liveRegion;
  function announce(msg) {
    if (!liveRegion) {
      liveRegion = document.createElement('div');
      liveRegion.className = 'a11y-widget-sr';
      liveRegion.setAttribute('aria-live', 'polite');
      liveRegion.setAttribute('aria-atomic', 'true');
      root.appendChild(liveRegion);
    }
    liveRegion.textContent = '';
    setTimeout(function () { liveRegion.textContent = msg; }, 50);
  }

  // ============================================================
  // EVENT BINDINGS
  // ============================================================
  function bindPanelEvents() {
    var closeBtn = panel.querySelector('.a11y-widget-close');
    if (closeBtn) closeBtn.addEventListener('click', function () { closePanel(true); });

    panel.querySelectorAll('[data-toggle]').forEach(function (el) {
      el.addEventListener('click', function () { toggleFeature(el.getAttribute('data-toggle')); });
    });

    panel.querySelectorAll('[data-action]').forEach(function (el) {
      el.addEventListener('click', function () {
        var a = el.getAttribute('data-action');
        if (a === 'tinc') setTextScale(0.1);
        else if (a === 'tdec') setTextScale(-0.1);
        else if (a === 'reset') resetAll();
      });
    });
  }

  function bindGlobalEvents() {
    btn.addEventListener('click', togglePanel);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('is-open')) {
        closePanel(true);
      }
    });

    // Click outside to close
    document.addEventListener('click', function (e) {
      if (root.classList.contains('is-open') && !root.contains(e.target)) {
        closePanel(false);
      }
    });
  }

  // ============================================================
  // BOOT
  // ============================================================
  function init() {
    injectCSS();
    document.body.appendChild(buildWidget());
    applyPrefs();
    bindPanelEvents();
    bindGlobalEvents();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
